import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSignalRStore = defineStore('signalR', () => {
  const hubConnection = ref<HubConnection | null>(null)
  const isConnected = ref(false)

  const connectionId = ref('')

  const startConnection = async () => {
    if (isConnected.value) {
      connectionId.value = hubConnection.value?.connectionId ?? ''
      return
    }

    hubConnection.value = new HubConnectionBuilder()
      .withUrl(`${process.env.VUE_APP_API_URL}/generalHub`)
      .withAutomaticReconnect([0, 1000, 5000, 10000, 30000])
      .build()

    hubConnection.value.onreconnecting(() => {
      isConnected.value = false
    })

    hubConnection.value.onreconnected(() => {
      isConnected.value = true
      connectionId.value = hubConnection.value?.connectionId ?? ''
    })

    hubConnection.value.onclose(() => {
      isConnected.value = false
      connectionId.value = ''
    })

    await hubConnection.value
      ?.start()
      .then(() => {
        isConnected.value = true
        connectionId.value = hubConnection.value?.connectionId ?? ''
      })
      .catch((error) => {
        console.error('Erro ao iniciar a conexão:', error)
      })
  }

  const stopConnection = async () => {
    await hubConnection.value?.stop()
    isConnected.value = false
    connectionId.value = ''
    hubConnection.value = null
  }

  return {
    connectionId,
    hubConnection,
    startConnection,
    stopConnection,
  }
})
